<template>
  <div v-if="list.length" class="list-item clearfix">
    <div v-for="(item, index) in list" :key="index">
      <div class="work-item" v-if="item.type == 'DTHB' || item.type == 'KCYX'" @click="click(item, index)">
        <!-- <van-image  @click.stop="deleteCourse(item,index)" src="static/imgs/application/applicatino_delete.png" class="delete_icon" /> -->
        <div>
          <van-image lazy-load class="work-img" radius="10px 10px 0 0" width="100%" height="100px" fit="cover"
            :src="item.thumbnail ? getImageUrl(item.thumbnail) : 'static/imgs/default_list_img.png'" />
        </div>
        <div :class="item.type == 'DTHB' ? 'work-item-bottom-DTHB' : 'work-item-bottom'">
          <div :class="item.type == 'DTHB' ? 'work-title-DTHB' : 'work-title'" v-html="item.name"></div>
          <dr-row v-if="item.viewCount != null && item.type != 'DTHB'" justifyContent="space-between" alignItems="center">
            <div class="read-num">{{ item.viewCount }}人学习</div>
            <div @click.stop="selectCourse">
              <van-checkbox v-if="isModifyCourse" class="read-num1" v-model="item.checked">
              </van-checkbox>
            </div>
          </dr-row>
        </div>
      </div>

      <dr-row v-if="item.type == 'RYZZ'" class="certificate_item" justifyContent="space-between" alignItems="center"
        @click="click(item, index)">
        <van-image lazy-load class="certificate_img" width="100%"  radius="10px" fit="cover"
          :src="item.thumbnail ? getImageUrl(item.thumbnail) : 'static/imgs/default_list_img.png'" />
        <!-- <div class="certificate_title">{{item.name}}</div> -->
      </dr-row>

      <van-swipe-cell :disabled="!hasSwipeDelete">
        <dr-row v-if="
          item.type == 'HYXW' ||
          item.type == 'BZJD' ||
          item.type == 'ZJFX' ||
          item.type == 'GSDT' ||
          item.type == 'KCYX_search' ||
          item.type == 'CPZX_search' ||
          item.type == 'DTHB_search' ||
          item.type == 'ZBTJ_search' ||
          item.type == 'JTJS' ||
          item.type == 'ZCZC' ||
          item.type == 'QYWH' ||
          item.type == 'RYZZ_search' ||
          item.type == 'ZXNS' ||
          item.type == 'DRXCP' ||
          item.type == 'CPZX' ||
          item.type == 'CJWT' ||
          item.type == 'CYQ' ||
          item.type == 'ZKY' ||
          item.type == 'SCY' ||
          item.type == 'OTHER'
        " class="search-item" justifyContent="flex-start" alignItems="center" @click="click(item, index)">
          <div class="search-item-left">
            <van-image lazy-load class="search-item-left-img" radius="10px" fit="cover"
              :src="item.thumbnail ? getImageUrl(item.thumbnail) : 'static/imgs/default_list_img.png'" />
          </div>
          <dr-column class="search-item-right" justifyContent="space-between">
            <div class="search-item-right-top" v-html="item.name"></div>
            <dr-row class="search-item-right-bottom" justifyContent="space-between" alignItems="center">
              <div>{{ item.content }}</div>
              <dr-row v-if="item.viewCount != null" justifyContent="flex-start" alignItems="center">
                <van-icon class="watch-icon" name="static/imgs/guanzhu.png" size="11" />
                <div>{{ item.viewCount }}</div>
              </dr-row>
            </dr-row>
          </dr-column>
        </dr-row>

        <dr-row v-if="item.type == 'PXTD'" class="search-item-PXTD" justifyContent="space-between" alignItems="center"
          @click="click(item, index)">
          <div class="search-item-right-top" v-html="item.name"></div>
          <dr-row class="search-item-right-bottom" justifyContent="space-between" alignItems="center">
            <div>{{ item.content }}</div>
            <dr-row v-if="item.viewCount != null" justifyContent="flex-start" alignItems="center">
              <van-icon class="watch-icon" name="static/imgs/guanzhu.png" size="11" />
              <div>{{ item.viewCount }}</div>
            </dr-row>
          </dr-row>
        </dr-row>

        <dr-row v-if="item.type == 'ZLK'" class="down-item"
          :class="index == 0 ? 'down-item-first' : (index == list.length - 1) ? 'down-item-last' : ''" justifyContent="space-between"
          alignItems="center" @click="pdfItemClick(item)">
          <van-icon name="static/imgs/pdf-icon.png" size="33" />
          <div class="down-title" v-html="item.name"></div>
          <div class="down-btn" @click.stop="pdfDownloadClick(item)">下 载</div>
        </dr-row>

        <dr-row v-if="item.type == 'XWXMS'" class="news-item" justifyContent="flex-start" alignItems="flex-start"
          @click="click(item, index)">
          <van-icon class="news-top-img" name="static/imgs/erji-icon.png" size="14" />
          <div class="news-right">
            <div class="news-title" v-html="item.name"></div>
            <dr-row class="news-right-bottom" justifyContent="space-between" alignItems="center">
              <div class="news-time">{{ item.content }}</div>
              <dr-row v-if="item.viewCount != null" justifyContent="flex-start" alignItems="center">
                <van-icon class="watch-icon" name="static/imgs/guanzhu.png" size="11" />
                <div style="color:#858585">{{ item.viewCount }}</div>
              </dr-row>
            </dr-row>
          </div>
        </dr-row>

        <dr-row v-if="item.type == 'ZBTJ'" class="play_item" justifyContent="space-between" alignItems="center"
          @click="click(item, index)">
          <van-image lazy-load class="play_img" width="100%" radius="10px" fit="cover"
            :src="item.thumbnail ? getImageUrl(item.thumbnail) : 'static/imgs/default_list_img.png'" />
          <div class="play_title" v-html="item.name"></div>
        </dr-row>

        <template #right>
          <dr-row style="height:100%">
            <div ref="delete" @click.stop="onDeleteClick(item, index)">
              <dr-column alignItems="center" class="delete">
                <van-icon name="static/imgs/download_delete.png" size="33" />
                <div class="delete-text">删除</div>
              </dr-column>
            </div>
          </dr-row>
        </template>
      </van-swipe-cell>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: []
    },
    type: {
      type: String,
      default: ""
    },
    hasSwipeDelete: {
      type: Boolean,
      default: false
    },
    isModifyCourse: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    list: {
      handler (val) {
        // console.log(val);
      },
      immediate: true
    }
  },
  data () {
    return {

    }
  },
  methods: {
    pdfDownloadClick (item) {
      this.$emit('pdfDownloadClick', item)
    },
    pdfItemClick (item) {
      this.$emit('pdfItemClick', item)
    },
    onDeleteClick (item, index) {
      this.$dialog.confirm({
        title: '确定删除吗？',
      }).then(() => {
        this.$emit("onDeleteSureClick", item, index)

      });
    },
    click (item, index) {
      this.$emit('click', item, index)
    },
    //选择我的课程
    selectCourse (val) {
      let arr = []
      this.list.forEach(item => {
        if (item.checked) {
          arr.push(item.id)
        }
      })
      if (arr.length == this.list.length) { //全选
        this.$emit('selectCourseAllStatus', true)
      } else { //非全选
        this.$emit('selectCourseAllStatus', false)
      }
    }
  },
}
</script>

<style scoped>
.list-item {
  width: 100%;
}

.work-item {
  width: calc(50% - 15px);
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  float: left;
}

.work-item-bottom {
  height: 75px;
  padding: 7px 6px 12px 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.work-item-bottom-DTHB {
  height: 62px;
  padding: 7px 6px 12px 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.work-img {
  max-height: 100px;
}

.work-title {
  color: #333333;
  font-size: 14px;
  line-height: 18px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.work-title-DTHB {
  color: #333333;
  font-size: 14px;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
  /* padding: 0 10px; */
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.read-num {
  font-size: 10px;
  color: #666666;
}

.read-num1 {
  padding-right: 10px;
}

.search-item {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.search-item-PXTD {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 5px 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  height: 78px;
}

.search-item-left {
  width: 40%;
}

.search-item-left-img {
  width: 119px;
  height: 68px;
  background-color: #f9f9f9;
}

.search-item-right {
  width: 60%;
  margin: 4px 0;
  height: 68px;
}

.search-item-right-top {
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.5;
}

.search-item-right-bottom {
  font-size: 12px;
  color: #858585;
  width: 100%;
}

.news-item {
  background-color: #ffffff;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  margin-bottom: 10px;
}

.news-top-img {
  width: 5%;
  margin-top: 4px;
}

.news-right {
  width: 95%;
}

.news-title {
  font-size: 15px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-right-bottom {
  margin-top: 10px;
}

.news-time {
  font-size: 12px;
  color: #868686;
}

.down-box {
  background-color: #ffffff;
  /* border-radius: 10px; */
  padding: 10px 10px 0 10px;
  box-sizing: border-box;
}

.down-item {
  background-color: #ffffff;
  padding: 10px;
}

.down-item-first {
  border-radius: 10px 10px 0 0;
}

.down-item-last {
  border-radius: 0 0 10px 10px;
}

.down-title {
  width: calc(100% - 113px);
  font-size: 13px;
  color: #333333;
}

.down-btn {
  width: 50px;
  text-align: center;
  border: 1px solid #0071ee;
  padding: 3px 0;
  /* box-sizing: border-box; */
  border-radius: 30px;
  color: #0071ee;
}

.watch-icon {
  margin-right: 5px;
}

.play_item {
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: 10px;
}

.play_img {
  width: 100%;
  height: 137px;
  background-color: #f9f9f9;
}

.play_title {
  color: #333333;
  font-size: 14px;
  margin: 10px 6px 10px 6px;
}

/deep/ .school-tab-con .van-tabs__content {
  height: calc(100% - 160px);
}

/deep/ .school-tab-con .van-tab__pane {
  height: 100%;
}

/deep/ .school-tab-con .van-tabs__wrap {
  height: 50px;
  font-size: 14px;
}

/deep/ .school-tab-con .van-tabs__line {
  bottom: 25px;
}

.delete-text {
  font-size: 12px;
  color: #ff0000;
  line-height: 14px;
  margin-top: 6px;
}

.delete {
  width: 42px;
  padding-right: 20px;
}

.certificate_item {
  width: calc(50% - 15px);
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  float: left;
  position: relative;
}

.certificate_img {
  height: 239px;
}

.certificate_title {
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
}

.delete_icon {
  width: 20px;
  height: 20px;
}</style>



// WEBPACK FOOTER //
// src/components/drListItem/index.vue